/** @format */
import axios from 'axios';

import { ContentfulQueryId } from '@toucan/common/contentful';
import { normalizeIsoCode } from '@toucan/common/helpers/language';

import { ContentfulQueryVariables } from '../config/types';

/**
 * Generic Contentful data fetcher
 */
export const getContentfulData = async <R = unknown>(
    queryId: ContentfulQueryId,
    locale: string,
    variables?: ContentfulQueryVariables
): Promise<R> => {
    const normalizedLocale = normalizeIsoCode(locale);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const { data } = await axios.post('/cms/contentful', {
        locale: normalizedLocale,
        queryId,
        variables,
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return data?.data ?? null;
};
